import { UsersDetailsWWGInfoTab } from "./UsersDetailsWWGInfoTab";

export default UsersDetailsWWGInfoTab;
